/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Loading/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import Indicator from './Indicator/index'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Loading({
  children,
  viewPath = "/DesignSystem/TimelineEvent/Note/Loading"
  
}) {
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtColorsOrange100 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.orange.100'
        })
let dtColorsOrange300 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.orange.300'
        })
  return (<React.Fragment
>
<div
  data-testid="Loading.Horizontal"
  data-view-path={viewPath}
 style={{'--mt-1-2mx3jB': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Horizontal}`}
>
<Indicator
  viewPath={`${viewPath}/Indicator`}
/>
<div
  data-testid="Loading.Horizontal:1"
  data-view-path={viewPath}
 style={{'--ml-2-2mx3jB': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--mr-3-2mx3jB': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--bc-4-2mx3jB': dtColorsOrange100,'--bc-5-2mx3jB': dtColorsOrange300,'--bblr-6-2mx3jB': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--bbrr-7-2mx3jB': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--btlr-8-2mx3jB': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--btrr-9-2mx3jB': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Horizontal1}`}
/>
</div>
{children}
</React.Fragment>)
}